import { RightOutlined, SearchOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import TimeScheduleReport from "./TimeScheduleReport";
import commonService from "../../api/common.service";
import AllReceiptView from "../../components/report/AllReceiptView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import { PRINT_BASE_URL } from "../../utility/URL";
const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth(),
    receipt_end_date: commonUtility.lastDateOfMonth(),
    member_id: "",
};



const AllReceiptReport = () => {
    const [form] = Form.useForm();



    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [programmeList, setProgrammeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);
    const [gstBill, setGstBill] = useState('');

    const onSelectMember = (value, obj) => {

        //const data = { formdata: { member_id: value } };
        form.setFieldsValue({
            member_id: value,
            enrollment_id: obj.enrollment_id
        });
    };


    const onFromDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedFromDate(dateString)
        form.setFieldsValue({
            receipt_start_date: dateString
        });
    };

    const onEndDateChange = (date, dateString) => {
        // console.log(date, dateString);
        setSelectedEndDate(dateString)
        form.setFieldsValue({
            receipt_end_date: dateString
        });

    };



    const onReportSearch = async (values) => {
        console.log('values', values);
        setReportList([])
        setFilteredSearchList([]);
        setGstBill(values.gst_bill);

        const formdValues = {
            programme_id: values.programme_id == undefined ? '' : values.programme_id,
            enrollment_id: values.enrollment_id == undefined ? '' : values.enrollment_id,
            member_id: values.member_id == undefined ? '' : values.member_id,
            from_date: values.receipt_start_date == undefined ? '' : values.receipt_start_date,
            to_date: values.receipt_end_date == undefined ? '' : values.receipt_end_date,
            gst_bill: values.gst_bill == undefined ? '' : values.gst_bill,
        }

        const data = { formdata: formdValues };

        ProgrammeService.allReceipt(data).then((res) => {

            if (res.data.response_status == SUCCESS_STATUS) {
                //  let formatted_data = ConvertedData(res.data);
                console.log('res.data', res.data);
                setReportList(res.data.response_data);
                setFilteredSearchList(res.data.response_data);
            }
            else {
                setReportList([])
                setFilteredSearchList([]);
            }
            setIsDataUpdated(!isDataUpdated)
        });
    };



    const onProgrammeChange = (id, object) => {

        getMemberList(object?.short_code)
    }



    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });

    }, []);


    /*
    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);
    */




    const getMemberList = (short_code) => {

        form.setFieldsValue({
            member_search: '',
            member_id: ''
        });

        const data = {
            formdata: {
                programme_id: short_code
            }
        };

        ProgrammeService.memberListPromoted(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }


    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        //    console.log(string.replace(/\s/g, '').toLowerCase());
        // const x = reportList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        const x = reportList.filter((data) => Object.values(data).join('').replace(/\s/g, '').toLowerCase().includes(string.replace(/(\s+|to)/g, '').toLowerCase()));
        setFilteredSearchList(x)
    }

    const handleExcelAllReceipt = async () => {
        try {
            const values = await form.validateFields();
            const url_excel = 'gstregister/all_receipt_report';
            let url = buildExcelUrl(values, url_excel);
            commonUtility.openInNewTab(url);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    const formatDate = (dateStr) => {
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const buildExcelUrl = (values, url_first) => {
        let url = '';
        const formValues = {
            from_date: formatDate(values.receipt_start_date) || '',
            to_date: formatDate(values.receipt_end_date) || '', 
            programme_id: values.programme_id || '0',
            enrollment_id: values.enrollment_id || '0',
            member_id: values.member_id || '0',
            gst_bill: values.gst_bill || ''
        };

        if (formValues.from_date !== "" && formValues.from_date !== "") {
            url = `${PRINT_BASE_URL}${url_first}/${formValues.from_date}/${formValues.to_date}/${formValues.programme_id}/${formValues.enrollment_id}/${formValues.member_id}/${formValues.gst_bill}`;
        }

        return url;
    };

    useEffect(() => {
        const formdValues = {
            member_id: form.getFieldValue('member_id') == undefined ? '' : form.getFieldValue('member_id'),
            receipt_start_date: commonUtility.firstDateOfMonth(),
            receipt_end_date: commonUtility.lastDateOfMonth(),
        }
    }, [])


    function disabledDate(current) {

        let sessionData = commonUtility.getLoggedInUserInfo();

        //console.log(sessionData.yearData.year);
        // Range of allowed dates        
        const startDate = new Date(sessionData.yearData.start_date); // Example start date
        const endDate = new Date(sessionData.yearData.end_date);   // Example end date

        // added 1 day to endDate as it is exclude while comparing (i.e March 31 is not selecting)
        endDate.setDate(endDate.getDate() + 1);

        // Return true if the date is not within the range
        return current < startDate || current > endDate;
    }

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="All Receipt Report"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >


                                        <Col xs={24} xl={3} >

                                            <Form.Item name="from_date_picker" label="From Date">
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onFromDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    // defaultValue={moment(commonUtility.firstDateOfMonth(), DATE_FORMAT_DMY_SLASH)}
                                                    disabledDate={disabledDate}

                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_start_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3} >

                                            <Form.Item name="to_date_picker" label="End Date" >
                                                <DatePicker
                                                    format={DATE_FORMAT_DMY_SLASH}
                                                    onChange={onEndDateChange}
                                                    style={{ width: "100%" }}
                                                    inputReadOnly={true}
                                                    // defaultValue={moment(commonUtility.lastDateOfMonth(), DATE_FORMAT_DMY_SLASH)}
                                                    disabledDate={disabledDate}
                                                />
                                            </Form.Item>
                                            <Form.Item name="receipt_end_date" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>

                                        </Col>

                                        <Col xs={4} xl={6}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"

                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={6} xl={6}>
                                            <Form.Item
                                                name="member_id"
                                                label="Member"
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        //option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    onSelect={(value, event) =>
                                                        onSelectMember(value, event)
                                                    }
                                                    allowClear={true}
                                                    onClear={() => {
                                                        form.setFieldsValue({
                                                            member_id: 0,
                                                            enrollment_id: 0
                                                        });
                                                    }}
                                                >
                                                    {memberList.length > 0
                                                        ? memberList.map((member_list) => (
                                                            <Option
                                                                key={member_list.member_id}
                                                                value={member_list.member_id}
                                                                enrollment_id={member_list.enrollment_id}
                                                            >
                                                                {`${member_list.member_fname} ${member_list.member_lname
                                                                    } | ${member_list.primary_mobile}`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>

                                            </Form.Item>

                                            <Form.Item name="enrollment_id" hidden={true}>
                                                <Input />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={10} xl={3}>
                                            <Form.Item
                                                name="gst_bill"
                                                label="Bill"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select GST Bill'
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left">
                                                    <Option value="Y">GST</Option>
                                                    <Option value="N">NON-GST</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>




                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={1} style={{ marginLeft: '10px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    onClick={handleExcelAllReceipt}
                                                >
                                                    <DownloadOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>


                                    </Row>
                                </Form>
                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        <div className='tableView'>
                            <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                            <div className="form-content">
                                <AllReceiptView gstBill={gstBill} reportList={filteredSearchList} isDataUpdatedValue={isDataUpdated} setFilteredSearchList={setFilteredSearchList} memberList={memberList} />
                            </div>
                        </div>




                    </div>

                </div>
            </div>

        </div>


    )
}

export default AllReceiptReport